import {
    CadastratarMotivoCancelamentoService,
    EditarMotivoCancelamentoService,
    DeletarMotivoCancelamentoService,
    ListarMotivoCancelamentoService,
} from "../../../../Services/Geral/GestaoDeCadastros/MotivoCancelamento/MotivoCancelamentoService";

import { MotivoCancelamentoInterface } from "../../../../Interfaces/Geral/GestaoDeCadastro/MotivoCancelamento/MotivoCancelamentoInterfaces";
import { Controller } from "../../../Controller";

export async function CadastrarMotivoCancelamentoController(
    requestBody: MotivoCancelamentoInterface
) {
    return Controller(CadastratarMotivoCancelamentoService(requestBody));
}

export async function EditarMotivoCancelamentoController(
    requestBody: MotivoCancelamentoInterface
) {
    return Controller(EditarMotivoCancelamentoService(requestBody));
}

export async function DeletarMotivoCancelamentoController(
    IDMotivoCancelamento: number
) {
    return Controller(DeletarMotivoCancelamentoService(IDMotivoCancelamento));
}

export async function ListarMotivoCancelamentoController(
    ID_TIPO_CASO: number,
    DS_PESQUISA: string
) {
    return Controller(
        ListarMotivoCancelamentoService(ID_TIPO_CASO, DS_PESQUISA)
    );
}
